// Team data structure — `photo` is intentionally null for now.
// Upload a professional photograph path (e.g. "/assets/team/sohan-gajadhane.jpg")
// later and the card will render it automatically.
export const TEAM = [
  {
    id: "sohan-gajadhane",
    name: "Sohan Gajadhane",
    role: "Senior Executive – Taxation & Compliance",
    qualifications: "B.Com, M.Com",
    photo: null,
  },
  {
    id: "akansha-mhatre",
    name: "Akansha Mhatre",
    role: "Senior Accounts Executive",
    qualifications: "B.Com",
    photo: null,
  },
  {
    id: "roshan-wagh",
    name: "Roshan Wagh",
    role: "Tax & GST Executive",
    qualifications: "B.Com",
    photo: null,
  },
  {
    id: "pratiksha-vispute",
    name: "Pratiksha Vispute",
    role: "Audit & Compliance Executive",
    qualifications: "B.Com",
    photo: null,
  },
  {
    id: "ankita-deshmukh",
    name: "Ankita Deshmukh",
    role: "Accounts & Compliance Executive",
    qualifications: "B.Com",
    photo: null,
  },
];

export const initials = (name) =>
  name
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
